module.exports = __webpack_public_path__ + "media/newstyle/images/second-circle-b2789f388dfcc7038e1fb3875efe7910.svg";